import { ThemeColor } from '@/enums'
import { useFormItem } from '@/providers'
import { themeColorFrom } from '@/utils'
import { RadioGroup, RadioGroupItem, RadioGroupItemProps } from '@surein/ui'
import styled from 'styled-components'
import { prop } from 'styled-tools'
import { getError } from '../FormItem/helpers'

const StyledMessage = styled.p`
  cursor: inherit;
  white-space: pre-line;
  line-height: 140%;
  font-weight: 700;
  font-size: 12px;
  color: ${themeColorFrom(prop('color'))};
`

interface FormRadioV2Props {
  name: string
  infoMessage?: string
  showErrorMessage?: boolean
  validateOnChange?: boolean
  children: any
  className?: string
}

export const FormRadioGroupV2 = ({
  name,
  infoMessage,
  showErrorMessage = true,
  children,
  className,
}: FormRadioV2Props) => {
  const { value, onChange, error } = useFormItem(name)
  const errorMsg = getError(error)
  const hasErrorMessage = Boolean(errorMsg && showErrorMessage)

  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      <RadioGroup value={value} onValueChange={onChange}>
        {children}
      </RadioGroup>

      {hasErrorMessage && (
        <StyledMessage color={ThemeColor.danger2}>
          {String(errorMsg)}
        </StyledMessage>
      )}

      {infoMessage && !hasErrorMessage && (
        <StyledMessage color={ThemeColor.b50}>{infoMessage}</StyledMessage>
      )}
    </div>
  )
}

interface FormRadioItemV2Props extends RadioGroupItemProps {
  size?: 'default' | 'lg'
  value: string
  name: string
}

export const FormRadioItemV2 = ({
  value,
  name,
  size = 'default',
}: FormRadioItemV2Props) => {
  const { error } = useFormItem(name)
  return (
    <RadioGroupItem
      value={value}
      id={value}
      isErrored={Boolean(error)}
      size={size}
    />
  )
}
